import React from "react"

import { Container, Row, Col } from "reactstrap"

class ProfileHeader extends React.Component {
  render() {
    return (
      <>
        <div
          className="header pb-6 d-flex align-items-center"
          style={{
            minHeight: "500px",
            backgroundImage:
              'url("' +
              require("assets/img/theme/placeholder-banner.jpg") +
              '")',
            backgroundSize: "cover",
            backgroundPosition: "center top",
          }}
        >
          <span className="mask bg-gradient-info opacity-8" />
          <Container className="d-flex align-items-center" fluid>
            <Row>
              <Col lg="7" md="10">
                <h1 className="display-2 text-white">
                  {"Hello " + (this.props.name || "")}
                </h1>
                <p className="text-white mt-0 mb-5">
                  This is your profile page. You can edit and update your
                  content here.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    )
  }
}

export default ProfileHeader
